import { CandleBreak } from './entryTactics/candleBreak/candleBreak';
import { LimitOrder } from './entryTactics/limitOrder/limitOrder';
import { MarketOrder } from './entryTactics/marketOrder/marketOrder';
import { AtrTrail } from './exitTactics/atrTrail/atrTrail';
import { BreakPrice } from './exitTactics/breakPrice/breakPrice';
import { CandleMagnitude } from './exitTactics/candleMagnitude/candleMagnitude';
import { CandleTrail } from './exitTactics/candleTrail/candleTrail';
import { FlattenBeforeMarketClose } from './exitTactics/flattenBeforeMarketClose/flatttenBeforeMarketClose';
import { GrabCents } from './exitTactics/grabCents/grabCents';
import { GreenToRedCandles } from './exitTactics/greenToRedCandles/greenToRedCandles';
import { GreenToRedPositions } from './exitTactics/greenToRedPositions/greenToRedPositions';
import { LossLimit } from './exitTactics/lossLimit/lossLimit';
import { MfeRetracement } from './exitTactics/mfeRetracement/mfeRetracement';
import { PositionBreakPrice } from './exitTactics/positionBreakPrice/positionBreakPrice';
import { PositionPriceTrail } from './exitTactics/positionPriceTrail/positionPriceTrail';
import { PreserveProfit } from './exitTactics/preserveProfit/preserveProfit';
import { RatchetBracket } from './exitTactics/ratchetBracket/ratchetBracket';
import { UnderlyingBreakPrice } from './exitTactics/underlyingBreakPrice/underlyingBreakPrice';
import { UnderlyingPriceExit } from './exitTactics/underlyingPriceExit/underlyingPriceExit';
import { UnderlyingPriceTrail } from './exitTactics/underlyingPriceTrail/underlyingPriceTrail';
import { AddToWinner } from './positionTactics/addToWinner/addToWinner';
import { ScalingIn } from './positionTactics/scalingIn/scalingIn';
import { EmaIntersectsFirstCandle } from './setupFilters/emaIntersectsFirstCandle/emaIntersectsFirstCandle';
import { Ftfc } from './setupFilters/ftfc/ftfc';
import { PriceIntersectsFirstCandle } from './setupFilters/priceIntersectsFirstCandle/priceIntersectsFirstCandle';
import { TimeOfDay } from './setupFilters/timeOfDay/timeOfDay';
import { AdHoc } from './setups/adHoc/adHoc';
import { Bounce } from './setups/bounce/bounce';
import { BounceEma } from './setups/bounceEma/bounceEma';
import { Break } from './setups/break/break';
import { BreakCandleType } from './setups/breakCandleType/breakCandleType';
import { BreakEma } from './setups/breakEma/breakEma';
import { CandlePattern } from './setups/candlePattern/candlePattern';
import { CandleTrigger } from './setups/candleTrigger/candleTrigger';
import { ConvictionCandle } from './setups/convictionCandle/convictionCandle';
import { Flag } from './setups/flag/flag';
import { Orb } from './setups/orb/orb';

export type TacticMap = {
  [index: string]: any,
}
export const tacticMap: TacticMap = {
  //setups
  CANDLE_PATTERN: CandlePattern,
  BREAK: Break,
  BOUNCE: Bounce,
  CONVICTION_CANDLE: ConvictionCandle,
  CANDLE_TRIGGER: CandleTrigger,
  BREAK_CANDLE_TYPE: BreakCandleType,
  ORB: Orb,
  BOUNCE_EMA: BounceEma,
  BREAK_EMA: BreakEma,
  FLAG: Flag,
  AD_HOC: AdHoc,

  //setup filters
  FTFC: Ftfc,
  FTFC_FILTER: Ftfc,
  TIME_OF_DAY: TimeOfDay,
  PRICE_INTERSECTS_FIRST_CANDLE: PriceIntersectsFirstCandle,
  EMA_INTERSECTS_FIRST_CANDLE: EmaIntersectsFirstCandle,

  //entry tactics
  MARKET_ORDER: MarketOrder,
  LIMIT_ORDER: LimitOrder,
  CANDLE_BREAK: CandleBreak,
  
  //position
  SCALING_IN: ScalingIn,
  ADD_TO_WINNER: AddToWinner,
 
  //exits
  BREAK_PRICE: BreakPrice,
  CANDLE_TRAIL: CandleTrail,
  GRAB_CENTS: GrabCents,
  GREEN_TO_RED_CANDLES: GreenToRedCandles,
  GREEN_TO_RED_POSITIONS: GreenToRedPositions,
  LOSS_LIMIT: LossLimit,
  POSITION_PRICE_TRAIL: PositionPriceTrail,
  PRESERVE_PROFIT: PreserveProfit,
  UNDERLYING_PRICE_TRAIL: UnderlyingPriceTrail,
  RATCHET_BRACKET: RatchetBracket,
  UNDERLYING_BREAK_PRICE: UnderlyingBreakPrice,
  CANDLE_MAGNITUDE: CandleMagnitude,
  ATR_TRAIL: AtrTrail,
  MFE_RETRACEMENT: MfeRetracement,
  UNDERLYING_PRICE_EXIT: UnderlyingPriceExit,
  POSITION_BREAK_PRICE: PositionBreakPrice,
  FLATTEN_BEFORE_MARKET_CLOSE: FlattenBeforeMarketClose,
};
